export function getSidebarEvent(trackingName: string) {
  return `Menu - Click ${trackingName}`;
}

export const signupEvents = {
  VIEW_PAGE: 'Signup - View page',
  FORM_SUBMITTED: 'Signup - Form submitted',
  VIEW_SET_PASSWORD: 'Signup - View Set password',
  PASSWORD_SET: 'Signup - Password set',
  PASSWORD_RESET: 'Signup - Password reset',
  EDIT_FIELD: 'Signup - Edit Field',
  HOVER_COUNTRY: 'Signup - Hover Country Tooltip',
  VIEW_PREV_PRODUCT: 'Signup - View Previous Product',
  VIEW_NEXT_PRODUCT: 'Signup - View Next Product',
  VIEW_INVITATION_SIGNUP: 'Signup - View Invitation Signup',
  SUBMIT_INVITATION_SIGNUP: 'Signup - Submit Invitation Signup',
};

export const userInviteEvents = {
  VIEW_PAGE: 'User Invites - View page',
  EDIT_FIELD: 'User Invites - Edit Field',
  FORM_SUBMITTED: 'User Invites - Form submitted',
  DELETE_INVITE: 'User Invites - Delete Invite',
  RESEND_INVITE: 'User Invites - Resend Invite',
  EDIT_INVITE: 'User Invites - Edit Invite',
  DELETE_USER: 'User Invites - Delete User',
};

export const signinEvents = {
  VIEW_PAGE: 'Signin - View page',
  SIGNIN_ATTEMPT: 'Signin - Attempt',
  SIGIN_ERROR: 'Signin - Error',
  SIGNEDIN: 'Signin - Success',
  TWO_FACTOR_SETUP: 'Signin - Two Factor Setup',
  TWO_FACTOR_SETUP_CANCEL: 'Signin - Two Factor Setup Cancel',
  TWO_FACTOR_SETUP_SUCCESS: 'Signin - Two Factor Setup Success',
};

export const homeEvents = {
  VIEW_PAGE: 'Home - View Page',
  APPLY_FOR_INVOICING: 'Home - Click Apply Invoice Financing',
  VIEW_INVOICE_FINANCING: 'Home - Click View Invoice Financing',
  CONTINUE_INVOICE_FINANCING: 'Home - Click Continue Invoice Financing',
  CONTINUE_INVOICE_FINANCING_NOTIFICATION: 'Home - Click Continue Application Notification',
  CONTINUE_INVOICE_FINANCING_NOTIFICATION_CLOSE: 'Home - Click Continue Application Notification - Close',
  CLICK_BUYER_CHECK: 'Home - Click Buyer Check',
  CLICK_LLC: 'Home - Click LLC',
  CLICK_FX: 'Home - Click FX',
  CLICK_INSURANCES: 'Home - Click Insurances',
  CLICK_VIEW_REFERRAL_TERMS: 'Home - Click View Referral Terms and Conditions',
  CLICK_COPY_REFERRAL: 'Home - Click Copy Referral',
  CLICK_ACKNOWLEDGEMENT_LINK: 'Home - Click Acknowledgement Agreement Link',
  CONFIRM_ACKNOWLEDGEMENT: 'Home - Click Confirm Acknowledgement',
};

export const invoiceEvents = {
  START: 'Invoice Financing - Application - Start',
  INTRO: 'Invoice Financing - Application - View Intro',
  STEP_ONE: 'Invoice Financing - Application - View Step 1',
  STEP_TWO: 'Invoice Financing - Application - View Step 2',
  STEP_THREE: 'Invoice Financing - Application - View Step 3',
  SUBMITTED: 'Invoice Financing - Application - Submitted',
  DOWNLOAD_TEMPLATE: 'Invoice Financing - Application - Download Template',
  UPLOAD_FILE: 'Invoice Financing - Application - Upload File',
  CHECKS_TERMS_AND_CONDITIONS: 'Invoice Financing - Application - Checks Terms and Conditions',
  EDIT_FIELD: 'Invoice Financing - Application - Edit Field',
  VIEW_PAGE: 'Invoice Financing - View page',
  ADD_CUSTOMER: 'Invoice Financing - Application - Click Add Customer',
  ADDED_CUSTOMER: 'Invoice Financing - Application - Customer Added',
  EDIT_CUSTOMER: 'Invoice Financing - Application - Click Edit Customer',
  EDITED_CUSTOMER: 'Invoice Financing - Application - Customer Edited',
  DELETE_CUSTOMER: 'Invoice Financing - Application - Click Delete Customer',
  DELETED_CUSTOMER: 'Invoice Financing - Application - Customer Deleted',
  CES_VIEW_SCORE: 'Invoice Financing - Application - CES View score',
  CES_EDIT_SCORE: 'Invoice Financing - Application - CES Edit score',
  CES_EXIT_SCORE: 'Invoice Financing - Application - CES Exit score',
  CES_SUBMIT_SCORE: 'Invoice Financing - Application - CES Submit score',
  CES_VIEW_FEEDBACK: 'Invoice Financing - Application - CES View feedback',
  CES_SUBMIT_FEEDBACK: 'Invoice Financing - Application - CES Submit feedback',
  CES_EXIT_FEEDBACK: 'Invoice Financing - Application - CES Exit feedback',
  CES_FINISHED_FEEDBACK: 'Invoice Financing - Application - CES View feedback submitted',
  START_FINANCING: 'Invoice Financing - Click Start Financing',
};

export const productCESEvents = {
  invoice_funding_request: {
    CES_VIEW_SCORE: 'Invoice Funding - CES View score',
    CES_EDIT_SCORE: 'Invoice Funding - CES Edit score',
    CES_EXIT_SCORE: 'Invoice Funding - CES Exit score',
    CES_SUBMIT_SCORE: 'Invoice Funding - CES Submit score',
    CES_VIEW_FEEDBACK: 'Invoice Funding - CES View feedback',
    CES_SUBMIT_FEEDBACK: 'Invoice Funding - CES Submit feedback',
    CES_EXIT_FEEDBACK: 'Invoice Funding - CES Exit feedback',
    CES_FINISHED_FEEDBACK: 'Invoice Funding - CES View feedback submitted',
  },
};

export type ProductKey = keyof typeof productCESEvents;

export const servicingEvents = {
  OPEN_WITHDRAWAL_MODAL: 'Servicing - Modal - Open Request Withdrawal Modal',
  SUBMIT_REQUEST_WITHDRAWAL: 'Servicing - Form - Submit Request Withdrawal',
  TOGGLED_FX_NEEDED: 'Servicing - Form - Toggled FX Needed',
  REQUEST_WITHDRAWAL_FORM: 'Servicing - Form - Edit Request Withdrawal Field',
  CLOSE_WITHDRAWAL_MODAL: 'Servicing - Modal - Close Request Withdrawal Modal',
  VIEW_OVERDUE: 'Servicing - Invoices - View Overdue',
  VIEW_IN_REVIEW: 'Servicing - Invoices - View In Review',
  GO_TO_CREDIT_DETAILS: 'Servicing - Dashboard - Click Go to Credit Details',
  VIEW_ALL_INVOICES: 'Servicing - Dashboard - Click View All Invoices',
  VIEW_ALL_TRANSFERS: 'Servicing - Dashboard - Click View All Transfers',
  VIEW_ALL_PAYMENTS: 'Servicing - Dashboard - Click View All Payments',
  INVOICES_TAB: 'Servicing - Dashboard - Click Invoices Tab',
  TRANSFERS_TAB: 'Servicing - Dashboard - Click Transfers Tab',
  PAYMENTS_TAB: 'Servicing - Dashboard - Click Payments Tab',
  OPEN_REACTIVATE_MODAL: 'Servicing - Open Reactivate Modal',
  CLOSE_REACTIVATE_MODAL: 'Servicing - Close Reactivate Modal',
  REQUEST_REACTIVATE_CREDIT_LINE: 'Servicing - Request Reactivate Credit Line',
  CLICK_INCREASE_CREDIT_LINE: 'Servicing - Click Increase Credit Line',
  INCREASE_CREDIT_LINE_EDIT_FIELD: 'Servicing - Increase Credit Line Edit Field',
  SUBMIT_INCREASE_CREDIT_LINE_REQUEST: 'Servicing - Submit Increase Credit Line Request',
  DOWNLOAD_FUNDING_TEMPLATE: 'Servicing - Download Funding Template',
  UPLOAD_FILE_FUNDING_REQUEST: 'Servicing - Upload File Funding Request',
  EDIT_FIELD_FUNDING_REQUEST: 'Servicing - Edit Field Funding Request',
  CLICK_NEXT_FUNDING_REQUEST_DRAWER: 'Servicing - Click Next Funding Request Drawer',
  CLICK_BACK_FUNDING_REQUEST_DRAWER: 'Servicing - Click Back Funding Request Drawer',
  CLICK_SUBMIT_FUNDING_REQUEST_DRAWER: 'Servicing - Click Submit Funding Request Drawer',
  CLICK_CLOSE_FUNDING_REQUEST_CONFIRMATION_MODAL:
    'Servicing - Click Close Funding Request Confirmation Modal',
  CLICK_FINANCE_INVOICES: 'Servicing - Click Finance Invoices',
  // MPSA Chat Drawer Events
  OPEN_MPSA_CHAT_DRAWER: 'Servicing - MPSA Chat - Open Drawer',
  CLOSE_MPSA_CHAT_DRAWER: 'Servicing - MPSA Chat - Close Drawer',
  SEND_MPSA_CHAT_MESSAGE: 'Servicing - MPSA Chat - Send Message',
};

export const termSheetEvents = {
  VIEW_PROPOSAL: 'Invoice Financing - Term Sheet - View proposal',
  CLOSE_CONFIRMATION_MODAL: 'Invoice Financing - Term Sheet - Close signed confirmation modal',
  VIEW_SIGNED_PROPOSAL: 'Invoice Financing - Term Sheet - View signed proposal',
};

export const docsCollectionEvents = {
  VIEW_DOCUMENTS_PAGE: 'Invoice Financing - Docs Collection - View documents page',
  CLICK_VIEW_GUIDE: 'Invoice Financing - Docs Collection - View Guide',
  CLICK_UPLOAD: 'Invoice Financing - Docs Collection - Click upload',
  CLICK_DOWNLOAD: 'Invoice Financing - Docs Collection - Click download',
  UPLOAD_DOC: 'Invoice Financing - Docs Collection - Upload Document',
  PREVIEW_DOC: 'Invoice Financing - Docs Collection - Preview Document',
  DELETE_DOC: 'Invoice Financing - Docs Collection - Delete Document',
  APPROVE_DOC: 'Invoice Financing - Docs Collection - Approve Document',
  REJECT_DOC: 'Invoice Financing - Docs Collection - Reject Document',
  TOGGLE_DOC: 'Invoice Financing - Docs Collection - Toggle Document',
  DOWNLOAD_ALL_DOCS: 'Invoice Financing - Docs Collection - Download All Documents',
  DOWNLOAD_BY_CATEGORY: 'Invoice Financing - Docs Collection - Download by category',
  DOWNLOAD_DOC: 'Invoice Financing - Docs Collection - Download Document',
  // SHAREHOLDERS
  OPEN_ADD_SHAREHOLDER_MODAL: 'Invoice Financing - Docs Collection - Open Add Shareholder Modal',
  OPEN_EDIT_SHAREHOLDER_MODAL: 'Invoice Financing - Docs Collection - Open Edit Shareholder Modal',
  DELETE_SHAREHOLDER: 'Invoice Financing - Docs Collection - Delete Shareholder',
  // LEGAL REPS
  OPEN_ADD_LEGAL_REP_MODAL: 'Invoice Financing - Docs Collection - Open Add Legal Representative Modal',
  OPEN_EDIT_LEGAL_REP_MODAL: 'Invoice Financing - Docs Collection - Open Edit Legal Representative Modal',
  DELETE_LEGAL_REP: 'Invoice Financing - Docs Collection - Delete Legal Representative',
  // STAKEHOLDERS
  EDIT_STAKEHOLDER_FORM: 'Invoice Financing - Docs Collection - Edit Stakeholder Form',
  UPLOAD_STAKEHOLDER_DOCUMENT: 'Invoice Financing - Docs Collection - Upload Stakeholder Document(s)',
  SAVE_STAKEHOLDER_FORM: 'Invoice Financing - Docs Collection - Save Stakeholder Form',
};

export const invoiceFinancingEvents = {
  CLICK_DISCOVER_MORE: 'Invoice Financing - Click Discover More',
};

export const creditLineEvents = {
  VIEW_MY_CREDIT: 'Invoice Financing - Credit Line - View my credit',
  CLOSE_CONFIRMATION_MODAL: 'Invoice Financing - Credit Line - Close approved confirmation modal',
  VIEW_CREDIT_LINE_DETAILS: 'Invoice Financing - Credit Line - View credit line details',
  VIEW_CONTRACT: 'Invoice Financing - Credit Line - View contract',
};

export const LLCEvents = {
  VIEW_PAGE: 'LLC - View page',
  SUBMIT_REQUEST: 'LLC - Submit Request',
  CLICK_DISCOVER_MORE: 'LLC - Click Discover More',
  FOLLOW_EMAIL_LINK: 'LLC - Follow Email Link',
  UPLOAD_DOCUMENT: 'LLC - Upload Document',
  VIEW_DOCUMENT: 'LLC - View Document',
  CLICK_SIGN_DOCUMENT: 'LLC - Click Sign Document',
  SET_LLC_STATUS: 'LLC - Set LLC Status',
  CLICK_COPY_EIN: 'LLC - Click Copy Ein',
  SET_LANGUAGE: 'LLC - Set Language',
  SEND_NOTIFICATION: 'LLC - Send Notification',
  UPDATE_DOCUMENT_SIGNATURE: 'LLC - Update Document Signature',
  DELETE_DOCUMENT: 'LLC - Delete Document',
  EDIT_COMPANY_INFORMATION_FIELD: 'LLC - Edit Company Information Field',
  EDIT_SHAREHOLDER_FIELD: 'LLC - Edit Shareholder Field',
  EDIT_LEGAL_REPRESENTATIVE_FIELD: 'LLC - Edit Legal Representative Field',
  REGISTERED_AGENT_OPTED_OUT: 'LLC - Registered Agent Opted Out',
  REGISTERED_AGENT_RENEWAL_CONTINUE: 'LLC - Registered Agent Renewal Continue',
  REGISTERED_AGENT_RENEWAL_OPTOUT: 'LLC - Registered Agent Renewal Optout',
  REGISTERED_AGENT_ADMIN_DISABLED: 'LLC - Registered Agent Admin Disabled',
  REGISTERED_AGENT_ADMIN_ENABLED: 'LLC - Registered Agent Admin Enabled',
};

export const buyerCheckEvents = {
  VIEW_PAGE: 'Buyer Check - View page',
  EDIT_FIELD: 'Buyer Check - Edit field',
  SUBMIT: 'Buyer Check - Submit request',
};

export const SATEvents = {
  CONNECT_SAT: 'Invoice Financing - Application - Click connect SAT',
  OPEN_SAT_HELP: 'Invoice Financing - Application - Click SAT Help',
  CLOSE_SAT_HELP: 'Invoice Financing - Application - Close SAT Help',
  CONNECT_SAT_SUCCESS: 'Invoice Financing - Application - SAT successful',
  CONNECT_SAT_ERROR: 'Invoice Financing - Application - SAT failed',
  TOGGLE_FLOW: 'Invoice Financing - Application - SAT Flow toggled',
};

export const adminEvents = {
  IMPERSONATE: 'Admin - Impersonate',
  CREATE_CASH_CONTROL_ACCOUNT: 'Admin - Create Cash Control Account',
  CREATE_CASH_CONTROL_ACCOUNT_SUCCESS: 'Admin - Create Cash Control Account Success',
  CREATE_CASH_CONTROL_ACCOUNT_ERROR: 'Admin - Create Cash Control Account Error',
};

export const myAccountEvents = {
  VIEW_PAGE: 'My Account - View Page',
  EDIT_PERSONAL_INFO: 'My Account - Edit Personal Info',
  EDIT_COMPANY_INFO: 'My Account - Edit Company Info',
  CHANGE_PASSWORD: 'My Account - Change Password',
  CHANGE_NOTIFICATIONS: 'My Account - Change Notifications',
};

export const buyersSummaryEvents = {
  VIEW_DETAILS: `Buyer's Summary - View Buyer Details`,
  CLICK_ADD_BUYER: `Buyer's Summary - Click Add New Buyer`,
  CLICK_APPLY_FILTERS: `Buyer's Summary - Click Apply Filters`,
  CLICK_RESET_FILTERS: `Buyer's Summary - Click Reset Filters`,
  EDIT_FILTER: `Buyer's Summary - Edit Filter`,
  ADD_NEW_BUYER_EDIT_FIELD: `Buyer's Summary - Add New Buyer Edit Field`,
  SUBMIT_ADD_NEW_BUYER_REQUEST: `Buyer's Summary - Submit Add New Buyer Request`,
  CLICK_INCREASE_BUYER_SUBLIMIT_BUYER: `Buyer's Summary - Click Increase Buyer Sublimit`,
  INCREASE_BUYER_SUBLIMIT_EDIT_FIELD: `Buyer's Summary - Increase Buyer Sublimit Edit Field`,
  SUBMIT_INCREASE_BUYER_SUBLIMIT_REQUEST: `Buyer's Summary - Submit Buyer Sublimit Request`,
  CLICK_EXPORT_BUYERS: `Buyer's Summary - Click Export Buyers`,
};

export const bankAccountEvents = {
  VIEW_PAGE: 'Bank Accounts - View Page',
  OPEN_ADD_MODAL: 'Bank Accounts - Open Add Modal',
  OPEN_EDIT_MODAL: 'Bank Accounts - Open Edit Modal',
  OPEN_DETAILS_MODAL: 'Bank Accounts - Open Details Modal',
  EDIT_FIELD: 'Bank Accounts - Edit Field',
  ADD_FILES: 'Bank Accounts - Add Files',
  REMOVE_FILE: 'Bank Accounts - Remove file',
  SUBMIT_NEW_ACCOUNT: 'Bank Accounts - Submit New Account',
  SUBMIT_EDIT_ACCOUNT: 'Bank Accounts - Edit Account',
  ACCEPT_BANK_ACCOUNT: 'Bank Accounts - Accept Account',
  REJECT_BANK_ACCOUNT: 'Bank Accounts - Reject Account',
};

export const followupEvents = {
  CLICK_FOLLOW_UP_EMAIL: 'Followup - Click email CTA',
};

export const invoicesEvents = {
  ALL_TAB: 'Invoices - Click All Tab',
  FINANCED_TAB: 'Invoices - Click Financed Tab',
  IN_REVIEW_TAB: 'Invoices - Click In Review Tab',
  VIEW_INVOICE_DETAIL: 'Invoices - View Invoice Detail',
  CLICK_FILTERS: 'Invoices - Click Filters Button',
  CLICK_APPLY_FILTERS: 'Invoices - Click Apply Filters',
  CLICK_RESET_FILTERS: 'Invoices - Click Reset Filters',
  EDIT_FILTER: 'Invoices - Edit Filter',
  CLICK_EXPORT_INVOICES: 'Invoices - Click Export Invoices',
  CLICK_VIEW_TRANSFERS: 'Invoices - Click View Transfers',
  CLICK_FINANCE_INVOICES: 'Invoices - Click Finance Invoices',
};

export const bankingEvents = {
  VIEW_DASHBOARD: 'Banking - Dashboard - View Page',
  LOCK_RATE_BANNER_CLICK_LEARN_MORE: 'Banking - Dashboard - Lock Rate Banner - Click Learn More',
  LOCK_RATE_BANNER_DISMISS: 'Banking - Dashboard - Lock Rate Banner - Dismiss',
  LOCK_RATE_HINT_CLICK_LEARN_MORE: 'Banking - Transfer - Lock Rate Hint - Click Learn More',
  CLICK_CONFIRM_AND_ACCEPT_TERMS_AND_CONDITIONS: 'Banking - Click Confirm and Accept Terms and Conditions',
  CLICK_START_BANKING: 'Banking - Click Start Banking',
  CLICK_TERMS_AND_CONDITIONS: 'Banking - Click Terms and Conditions',
  VIEW_CONNECTED_ACCOUNTS_PAGE: 'Banking - Connected Accounts - View Page',
  VIEW_CASH_CONTROL_CONNECTED_ACCOUNTS_PAGE: 'Banking - Cash Control Connected Accounts - View Page',
  VIEW_CONNECTED_ACCOUNT_DETAIL_PAGE: 'Banking - Connected Accounts - View Detail Page',
  ACTIVATE_CONNECTED_ACCOUNT: 'Banking - Connected Accounts - Activate Account',
  CREATE_KYC: 'Banking - Connected Accounts - Create KYC',
  RFI_BANNER_CTA_CLICKED: 'Banking - RFI - Banner CTA Clicked',
  RFI_NOTICE_CTA_CLICKED: 'Banking - RFI - Notice CTA Clicked',
  VIEW_RFI_PAGE: 'Banking - RFI - View Page',
  RFI_SUBMITTED: 'Banking - RFI - Submitted',
  RFIS_VIEW_PAGE: 'Banking - RFIs - View Page',
  RFIS_APPLY_FILTERS: 'Banking - RFIs - Apply Filters',
  RFIS_CHANGE_PAGE: 'Banking - RFIs - Change Page',
  RFIS_VIEW_DETAILS: 'Banking - RFIs - View Details',
  LOW_ACTIVITY_VIEW_PAGE: 'Banking - Low Activity Accounts - View Page',
  LOW_ACTIVITY_EXPORT: 'Banking - Low Activity Accounts - Export',
  LOW_ACTIVITY_IMPORT: 'Banking - Low Activity Accounts - Import',
  LOW_ACTIVITY_REMOVE: 'Banking - Low Activity Accounts - Remove',
  LOW_ACTIVITY_TOGGLE: 'Banking - Low Activity Accounts - Toggle On Account',
  DEBITS_BLOCK_TOGGLE: 'Banking - Account Debits Block - Toggle On Account',
  VIEW_PAGE: 'Banking - View Product Page',
  SUBMIT_REQUEST: 'Banking - Submit Request',
  CLICK_DISCOVER_MORE: 'Banking - Click Discover More',
  CLICK_CONTINUE_APPLICATION: 'Banking - Click Continue Application',
  CLICK_GO_TO_HOME: 'Banking - Click Go To Home',
  OPEN_ADD_FUNDS: 'Banking - Add Funds - Open Drawer',
  OPEN_CREATE_TRANSFER: 'Banking - Create Transfer - Open Drawer',
  OPEN_CREATE_CONVERSION: 'Banking - Create Conversion - Open Drawer',
  ADD_FUNDS_CHANGE_ACCOUNT: 'Banking - Add Funds - Change Account',
  ADD_FUNDS_TOGGLE_MORE_DETAILS: 'Banking - Add Funds - Toggle More Details',
  ADD_FUNDS_CLICK_COPY_ALL: 'Banking - Add Funds - Click Copy All Details',
  ADD_FUNDS_CLICK_COPY: 'Banking - Add Funds - Click Copy Details',
  VIEW_ACCOUNT_DETAIL_PAGE: 'Banking - Account Detail - View Page',
  VIEW_ACCOUNT_ALL_DETAILS: 'Banking - Account Detail - Show All Details',
  // All Transactions
  ALL_TRANSACTIONS_VIEW_PAGE: 'Banking - All Transactions - View Page',
  ALL_TRANSACTIONS_APPLY_FILTERS: 'Banking - All Transactions - Apply Filters',
  TRANSACTIONS_VIEW_TRANSACTION_DETAILS: 'Banking - All Transactions - View Transaction Details',
  TRANSACTIONS_CHANGE_PAGE: 'Banking - All Transactions - Change Page',
  // Transfers
  TRANSFERS_VIEW_PAGE: 'Banking - Transfers - View Page',
  TRANSFERS_APPLY_FILTERS: 'Banking - Transfers - Apply Filters',
  TRANSFERS_REQUESTS_APPLY_FILTERS: 'Banking - Transfers - Requests Apply Filters',
  TRANSFERS_CHANGE_PAGE: 'Banking - Transfers - Change Page',
  TRANSFERS_REQUESTS_CHANGE_PAGE: 'Banking - Transfers - Requests Change Page',
  TRANSFERS_VIEW_DETAILS: 'Banking - Transfers - View Details',
  TRANSFERS_REQUESTS_VIEW_DETAILS: 'Banking - Transfers - Requests View Details',
  BATCH_TRANSFERS_VIEW_DETAILS: 'Banking - Batch Transfers - View Details',
  BATCH_TRANSFERS_CHANGE_PAGE: 'Banking - Batch Transfers - Change Page',
  // Connected Accounts
  CONNECTED_ACCOUNTS_APPLY_FILTERS: 'Banking - Connected Accounts - Apply Filters',
  CONNECTED_ACCOUNTS_EDIT_FILTER: 'Banking - Connected Accounts - Edit Filter',
  CONNECTED_ACCOUNTS_CLEAR_FILTERS: 'Banking - Connected Accounts - Clear Filters',
  // Cash Control Connected Accounts
  CASH_CONTROL_CONNECTED_ACCOUNTS_APPLY_FILTERS: 'Banking - Cash Control Connected Accounts - Apply Filters',
  CASH_CONTROL_CONNECTED_ACCOUNTS_EDIT_FILTER: 'Banking - Cash Control Connected Accounts - Edit Filter',
  CASH_CONTROL_CONNECTED_ACCOUNTS_CLEAR_FILTERS: 'Banking - Cash Control Connected Accounts - Clear Filters',
  // Recipients
  RECIPIENTS_VIEW_PAGE: 'Banking - Recipients - View Page',
  CLICK_CREATE_RECIPIENT: 'Banking - Recipients - Click Create Recipient',
  SUBMIT_CREATE_RECIPIENT: 'Banking - Recipients - Submit Create Recipient',
  CREATED_RECIPIENT: 'Banking - Recipients - Created Recipient',
  SUBMIT_CREATE_RECIPIENT_AFTER_TRANSFER: 'Banking - Recipients - Submit Create Recipient After Transfer',
  SUBMIT_EDIT_RECIPIENT: 'Banking - Recipients - Submit Edit Recipient',
  CLICK_SAVE_RECIPIENT: 'Banking - Transfers - Click Save Recipient',
  DELETE_RECIPIENT: 'Banking - Recipients - Delete Recipient',
  // Transfers
  TRANSFERS_ALL_TAB: 'Banking - Transfers - All Tab',
  TRANSFERS_REQUESTS_TAB: 'Banking - Transfers - Requests Tab',
  BATCH_TRANSFERS_TAB: 'Banking - Batch Transfers - Tab',
  CLICK_CREATE_TRANSFER: 'Banking - Transfers - Click Create Transfer',
  CLICK_CREATE_TRANSFER_EXISTING_RECIPIENT: 'Banking - Transfers - Click Create Transfer Existing Recipient',
  CLICK_CREATE_TRANSFER_NEW_RECIPIENT: 'Banking - Transfers - Click Create Transfer New Recipient',
  EDIT_FIELD_BANKING_TRANSFER_FORM: 'Banking - Transfers - Edit Field Banking Transfer Form',
  CLICK_CONTINUE_TRANSFER_WITH_RECIPIENT: 'Banking - Transfers - Click Continue Transfer With Recipient',
  EDIT_FIELD_BANKING_TRANSFER_REVIEW_FORM: 'Banking - Transfers - Edit Field Banking Transfer Review Form',
  SUBMIT_CREATE_TRANSFER: 'Banking - Transfers - Submit Create Transfer',
  CREATED_TRANSFER: 'Banking - Transfers - Created Transfer',
  CLICK_NEW_TRANSFER: 'Banking - Transfers - Click New Transfer',
  CLICK_DONE: 'Banking - Transfers - Click Done',
  CLICK_SHARE_TRANSFER_RECEIPT: 'Banking - Transfers - Click Share Transfer Receipt',
  CLOSE_SHARE_TRANSFER_RECEIPT: 'Banking - Transfers - Close Share Transfer Receipt',
  SUBMIT_SHARE_TRANSFER_RECEIPT: 'Banking - Transfers - Submit Share Transfer Receipt',
  SHARE_TRANSFER_RECEIPT: 'Banking - Transfers - Share Transfer Receipt',
  // Batch Transfers
  CLICK_CREATE_BATCH_TRANSFER: 'Banking - Transfers - Click Create Batch Transfer',
  // Wallet-to-Wallet Transfers
  CLICK_CREATE_WALLET_TRANSFER: 'Banking - Transfers - Click Create Wallet Transfer',
  CLICK_CONTINUE_BATCH_TRANSFER_SOURCE_ACCOUNT: 'Banking - Batch Transfers - Click Continue Source Account',
  EDIT_FIELD_BATCH_TRANSFER: 'Banking - Batch Transfers - Edit Field',
  CLICK_CONTINUE_BATCH_TRANSFER_DETAILS: 'Banking - Batch Transfers - Click Continue Transfer Details',
  SUBMIT_CREATE_BATCH_TRANSFER: 'Banking - Batch Transfers - Submit Create Batch Transfer',
  CREATED_BATCH_TRANSFER: 'Banking - Batch Transfers - Created Batch Transfer',
  CLICK_NEW_BATCH_TRANSFER: 'Banking - Batch Transfers - Click New Batch Transfer',
  CLICK_DONE_BATCH_TRANSFER: 'Banking - Batch Transfers - Click Done',
  // Conversions
  CONVERSIONS_VIEW_PAGE: 'Banking - Conversions - View Page',
  CLICK_CREATE_CONVERSION: 'Banking - Conversions - Click Create Conversion',
  SUBMIT_CREATE_CONVERSION: 'Banking - Conversions - Submit Create Conversion',
  CREATED_CONVERSION: 'Banking - Conversions - Created Conversion',
  CLICK_NEW_CONVERSION: 'Banking - Conversions - Click New Conversion',
  CLICK_CONVERSION_DONE: 'Banking - Conversions - Click Done',
  CONVERSIONS_APPLY_FILTERS: 'Banking - Conversions - Apply Filters',
  CONVERSIONS_VIEW_DETAILS: 'Banking - Conversions - View Details',
  CONVERSIONS_CHANGE_PAGE: 'Banking - Conversions - Change Page',
  // Cards
  CARDS_VIEW_PAGE: 'Banking - Cards - View Page',
  CLICK_CREATE_COMPANY_CARD: 'Banking - Cards - Click Create Company Card',
  CLICK_CREATE_EMPLOYEE_CARD: 'Banking - Cards - Click Create Employee Card',
  EDIT_FIELD_NEW_COMPANY_CARD: 'Banking - Cards - Edit Field New Company Card',
  EDIT_FIELD_EMPLOYEE_INFORMATION: 'Banking - Cards - Edit Field Employee Information',
  EDIT_FIELD_NEW_EMPLOYEE_CARD: 'Banking - Cards - Edit Field New Employee Card',
  EDIT_FIELD_UPDATE_CARD: 'Banking - Cards - Edit Field Update Card',
  CLICK_SUBMIT_NEW_COMPANY_CARD: 'Banking - Cards - Click Submit New Company Card',
  CLICK_SUBMIT_NEW_EMPLOYEE_CARD: 'Banking - Cards - Click Submit New Employee Card',
  CREATED_NEW_COMPANY_CARD: 'Banking - Cards - Created New Company Card',
  CREATED_NEW_EMPLOYEE_CARD: 'Banking - Cards - Created New Employee Card',
  CREATED_NEW_CARDHOLDER: 'Banking - Cards - Created New Cardholder',
  UPDATED_CARD: 'Banking - Cards - Updated Card',
  CLICK_CREATE_ANOTHER_COMPANY_CARD: 'Banking - Cards - Click Create Another Company Card',
  CLICK_VIEW_COMPANY_CARD_DETAILS: 'Banking - Cards - Click View Company Card Details',
  CLICK_BACK_TO_CARDS: 'Banking - Cards - Click Back to Cards',
  CLICK_DONE_EMPLOYEE_CARD: 'Banking - Cards - Click Done Employee Card',
  CLICK_CLOSE_NEW_COMPANY_CARD: 'Banking - Cards - Click Close New Company Card',
  CLICK_CLOSE_NEW_EMPLOYEE_CARD: 'Banking - Cards - Click Close New Employee Card',
  CLICK_CLOSE_UPDATE_CARD: 'Banking - Cards - Click Close Update Card',
  CLICK_EDIT_CARD_DETAILS: 'Banking - Cards - Click Edit Card Details',
  CLICK_EDIT_CARDHOLDER: 'Banking - Cards - Click Edit Cardholder',
  CLICK_FREEZE_CARD: 'Banking - Cards - Click Freeze Card',
  CLICK_UNFREEZE_CARD: 'Banking - Cards - Click Unfreeze Card',
  CLICK_REPLACE_CARD: 'Banking - Cards - Click Replace Card',
  CLICK_CANCEL_CARD: 'Banking - Cards - Click Cancel Card',
  CLICK_VIEW_CARD_DETAILS: 'Banking - Cards - Click View Card Details',
  CLICK_HIDE_CARD_DETAILS: 'Banking - Cards - Click Hide Card Details',
  CLICK_VIEW_CARD_PIN: 'Banking - Cards - Click View Card PIN',
  CLICK_HIDE_CARD_PIN: 'Banking - Cards - Click Hide Card PIN',
  CARDS_VIEW_DETAILS: 'Banking - Cards - View Details',
  CARDS_CHANGE_PAGE: 'Banking - Cards - Change Page',
  CARDS_ALL_TAB: 'Banking - Cards - All Tab',
  CARDS_COMPANY_TAB: 'Banking - Cards - Company Tab',
  CARDS_EMPLOYEE_TAB: 'Banking - Cards - Employee Tab',
  CLICK_CARDS_SETTINGS: 'Banking - Cards - Settings',
  CARDS_ALL_ACCOUNTS_APPLY_FILTERS: 'Banking - Cards all accounts - Apply Filters',
  CARDS_ALL_ACCOUNTS_VIEW_PAGE: 'Banking - Cards all accounts - View Page',
  // Global Accounts
  GLOBAL_ACCOUNTS_VIEW_PAGE: 'Banking - Global Accounts - View Page',
  CLICK_CREATE_GLOBAL_ACCOUNT: 'Banking - Global Accounts - Click Create Global Account',
  CREATE_GLOBAL_ACCOUNT: 'Banking - Global Accounts - Create Global Account',
  CREATE_GLOBAL_ACCOUNT_SUCCESS: 'Banking - Global Accounts - Create Global Account Success',
  CREATE_GLOBAL_ACCOUNT_ERROR: 'Banking - Global Accounts - Create Global Account Error',
  CLICK_VIEW_GLOBAL_ACCOUNT: 'Banking - Global Accounts - Click View Global Account',
  GLOBAL_ACCOUNTS_CHANGE_PAGE: 'Banking - Global Accounts - Change Page',
  GLOBAL_ACCOUNT_VIEW_DETAILS: 'Banking - Global Accounts - View Details',
  // Reports
  VIEW_REPORTS_PAGE: 'Banking - Reports - View Page',
  DOWNLOAD_CONFIRMATION_LETTER: 'Banking - Reports - Download Confirmation Letter',
  // Transfer Approvals
  CLICK_ADD_TRANSFER_APPROVAL_WORKFLOW: 'Banking - Transfer Approvals - Click Add Transfer Approval Workflow',
  SUBMIT_CREATE_TRANSFER_APPROVAL: 'Banking - Transfer Approvals - Submit Create Transfer Approval',
  CLICK_EDIT_TRANSFER_APPROVAL_WORKFLOW:
    'Banking - Transfer Approvals - Click Edit Transfer Approval Workflow',
  SUBMIT_EDIT_TRANSFER_APPROVAL: 'Banking - Transfer Approvals - Submit Edit Transfer Approval',
  CREATED_TRANSFER_APPROVAL: 'Banking - Transfer Approvals - Created Transfer Approval',
  UPDATED_TRANSFER_APPROVAL: 'Banking - Transfer Approvals - Updated Transfer Approval',
  DELETE_TRANSFER_APPROVAL: 'Banking - Transfer Approvals - Delete Transfer Approval',
};

export const reportingEvents = {
  CLICK_GENERATE_REPORT: 'Reporting - Click Generate Report',
  SUBMIT_GENERATE_REPORT: 'Reporting - Submit Generate Report',
  INSIGHTS_TAB: 'Reporting - Click Insights Tab',
  REPORTS_TAB: 'Reporting - Click Reports Tab',
  CLICK_VIEW_PRESENTATION: 'Reporting - Click View Presentation',
  ACTIVITY_REPORT_TYPE_CHANGE: 'Activity Report Type Change',
};

export const trackingEvents = {
  VIEW_TRACKING_PAGE: 'Tracking - View Page',
  VIEW_PUBLIC_TRACKING_PAGE: 'Tracking - View Public Page',
  CLICK_APPLY_FILTERS: 'Tracking - Click Apply Filters',
  CLICK_CLEAR_FILTERS: 'Tracking - Clear Click Filters',
  EDIT_FILTER: 'Tracking - Edit Filter',
  CLICK_CONNECT_INVOICE: 'Tracking - Click Connect Invoice',
  SUBMIT_CONNECT_INVOICE: 'Tracking - Submit Connect Invoice',
  CLICK_TRACK_SHIPMENT: 'Tracking - Click Track Shipment',
};

export const marcoWrappedEvents = {
  FOLLOW_EMAIL_LINK: 'Marco Wrapped - Follow Email Link',
  CLICK_HOME_BANNER: 'Marco Wrapped - Click Home Banner',
  CLICK_MODAL_NEXT_BUTTON: 'Marco Wrapped - Click Modal Next Button',
  CLICK_VEW_MORE_INSIGHTS_BUTTON: 'Marco Wrapped - Click View More Insights Button',
};

export const transfersEvents = {
  CLICK_APPLY_FILTERS: `Transfers - Click Apply Filters`,
  CLICK_RESET_FILTERS: `Transfers - Click Reset Filters`,
  EDIT_FILTER: `Transfers - Edit Filter`,
  VIEW_TRANSFER_DETAIL: 'Transfers - View Transfer Detail',
  SHOW_TRANSFER_ALLOCATIONS_DRAWER: 'Transfers - Show Transfer Allocations Drawer',
  SHOW_TRANSFER_DETAILS_DRAWER: 'Transfers - Show Transfer Details Drawer',
  SHOW_INVOICE_DETAILS_DRAWER: 'Transfers - Show Invoice Details Drawer',
};

export const notificationEvents = {
  OPEN_NOTIFICATION: 'Notification - Click',
};

export const paymentsEvents = {
  VIEW_PAYMENT_DETAIL: 'Payments - View Payment Detail',
  SHOW_PAYMENT_DETAILS_DRAWER: 'Payments - Show Payment Details Drawer',
  SHOW_PAYMENT_ALLOCATIONS_DRAWER: 'Payments - Show Payment Allocations Drawer',
  SHOW_INVOICE_DETAILS_DRAWER: 'Payments - Show Invoice Details Drawer',
  CLICK_APPLY_FILTERS: 'Payments - Click Apply Filters',
  CLICK_RESET_FILTERS: 'Payments - Click Reset Filters',
  EDIT_FILTER: 'Payments - Edit Filter',
};

export const CompanyEvents = {
  EDIT_COMPANY_INFORMATION_FIELD: 'Company - Edit Company Information Field',
};

export const financeRequestEvents = {
  EDIT_FILTER: 'Finance Request - Edit Filter',
  CLICK_APPLY_FILTERS: 'Finance Request - Click Apply Filters',
  CLICK_RESET_FILTERS: 'Finance Request - Click Reset Filters',
  COMPLETED_TAB: 'Finance Request - Click Completed Tab',
  PROCESSING_TAB: 'Finance Request - Click Processing Tab',
  DRAFT_TAB: 'Finance Request - Click Draft Tab',
  NEEDS_ATTENTION_TAB: 'Finance Request - Click Needs Attention Tab',
  CLICK_FINANCE_INVOICES: 'Finance Request - Click Finance Invoices',
  CLICK_VIEW_DETAILS: 'Finance Request - Click View Details',
  CLICK_CLOSE_DETAILS: 'Finance Request - Click Close Details',
  CLICK_DELETE_DRAFT_REQUEST: 'Finance Request - Click Delete Draft Request',
  CLICK_ADD_INVOICE: 'Finance Request - Click Add Invoice',
  UPLOAD_FILE: 'Finance Request - Upload File',
  DELETE_FILE: 'Finance Request - Delete File',
  EDIT_FIELD: 'Finance Request - Edit Field',
  UPLOAD_SUPPORTING_DOCUMENTS: 'Finance Request - Upload Supporting Documents',
  DELETE_SUPPORTING_DOCUMENT: 'Finance Request - Delete Supporting Document',
  CHECK_SUPPORTING_DOCUMENTS_NOT_REQUIRED: 'Finance Request - Check Supporting Documents Not Required',
  MOVE_TO_NEXT_STEP: 'Finance Request - Move to next step',
  MOVE_TO_PREVIOUS_STEP: 'Finance Request - Move to previous step',
  CREATE_INVOICE: 'Finance Request - Create Invoice',
  UPDATE_INVOICE: 'Finance Request - Update Invoice',
  CLICK_EDIT_INVOICE: 'Finance Request - Click Edit Invoice',
  CLICK_DELETE_INVOICE: 'Finance Request - Click Delete Invoice',
  CHECK_RELEASE_RESERVES: 'Finance Request - Check Release Reserves',
  ADDITIONAL_INFORMATION: 'Finance Request - Additional Information',
  RELEASE_AMOUNT: 'Finance Request - Release Amount',
  SELECT_BANK_ACCOUNT: 'Finance Request - Select Bank Account',
  SELECT_TRANSFER_TYPE: 'Finance Request - Select Transfer Type',
  CLICK_REVIEW_REQUEST: 'Finance Request - Click Review Request',
  CHECK_SUBMIT_SCHEDULE_OF_ACCOUNTS: 'Finance Request - Check Submit Schedule of Accounts',
  CLICK_SUBMIT_REQUEST: 'Finance Request - Click Submit Request',
  CLOSE_SUBMISSION_MODAL: 'Finance Request - Close Submission Modal',
  SHOW_REQUEST_DETAILS_DRAWER: 'Finance Request - Show Request Details Drawer',
  SHOW_FINANCE_DETAILS_DRAWER: 'Finance Request - Show Finance Details Drawer',
  VIEW_COMPLETED_FINANCE_REQUEST: 'Finance Request - View Completed Finance Request',
  VIEW_PROCESSING_FINANCE_REQUEST: 'Finance Request - View Processing Finance Request',
  CLICK_GENERATE_REPORT: 'Finance Request - Click Generate Report',
  DOWNLOAD_FINANCE_TEMPLATE: 'Finance Request - Download Finance Template',
  UPLOAD_FINANCE_TEMPLATE: 'Finance Request - Upload Finance Template',
  DELETE_FINANCE_TEMPLATE: 'Finance Request - Delete Finance Template',
  SUBMIT_BULK_SPREADSHEET_FLOW: 'Finance Request - Submit Bulk Spreadsheet Flow',
  CLICK_SAVE_CHANGES_AND_EXIT: 'Finance Request - Click Save Changes and Exit',
  CLICK_CONTINUE_WITH_THE_PROCESS: 'Finance Request - Click Continue with the Process',
  CLICK_CLOSE_REVIEW_PAGE: 'Finance Request - Click Close Review Page',
  VIEW_INVOICE_DETAIL: 'Finance Request - View Invoice Detail',
  MODIFY_SOA: 'Finance Request - Modify SoA',
};

export const emailLinkEvents = {
  funding_request_flow_sign_email_clicked: 'Finance Request - Click Sign Email Link',
  default: 'Email Link - Click',
};

export const twoFactorEvents = {
  // Set Up Modal
  CLICK_SET_UP_TWO_FACTOR_FROM_SECURITY_TAB: 'Two Factor - Click Set Up Two Factor from Security Tab',
  CLICK_CLOSE_MODAL: 'Two Factor - Click Close Set Up Two Factor Modal',
  // Set Up Modal - Step 1
  CLICK_SET_UP_LATER: 'Two Factor - Click Set Up Later',
  CLICK_SET_UP_NOW: 'Two Factor - Click Set Up Now',
  RETRIEVE_QR_CODE_SUCCESS: 'Two Factor - Retrieve QR Code Success',
  RETRIEVE_QR_CODE_ERROR: 'Two Factor - Retrieve QR Code Error',
  // Set Up Modal - Step 2
  CLICK_CANCEL_SET_UP: 'Two Factor - Click Cancel Set Up',
  CLICK_NEXT: 'Two Factor - Click Next',
  CLICK_MANUAL_CODE_TOGGLE: 'Two Factor - Click Manual Code Toggle',
  CLICK_COPY_SECRET_KEY: 'Two Factor - Click Copy Secret Key',
  // Set Up Modal - Step 3
  CLICK_PREVIOUS: 'Two Factor - Click Previous',
  CLICK_VERIFY_CODE: 'Two Factor - Click Verify Code',
  TWO_FACTOR_VERIFICATION_SUCCESS: 'Two Factor - Verification Success',
  TWO_FACTOR_VERIFICATION_ERROR: 'Two Factor - Verification Error',
  // Set Up Modal - Step 4
  CLICK_COPY_RECOVERY_CODES: 'Two Factor - Click Copy Recovery Codes',
  CLICK_DOWNLOAD_RECOVERY_CODES: 'Two Factor - Click Download Recovery Codes',
  CLICK_DONE: 'Two Factor - Click Setup Done',
  // Authentication
  TWO_FACTOR_ATTEMPT: 'Two Factor - Verification Attempt',
  TWO_FACTOR_ERROR: 'Two Factor - Verification Error',
  TWO_FACTOR_SUCCESS: 'Two Factor - Verification Success',
  TWO_FACTOR_CANCEL: 'Two Factor - Cancel',
  RECOVERY_CODE_ATTEMPT: 'Two Factor - Recovery Code Attempt',
  RECOVERY_CODE_SUCCESS: 'Two Factor - Recovery Code Success',
  RECOVERY_CODE_ERROR: 'Two Factor - Recovery Code Error',
  // Generate Recovery Code Modal
  CLICK_GENERATE_RECOVERY_CODE_FROM_SECURITY_TAB:
    'Two Factor - Click Generate Recovery Code from Security Tab',
  CLICK_CLOSE_GENERATE_RECOVERY_CODE_MODAL: 'Two Factor - Click Close Generate Recovery Code Modal',
  GENERATE_RECOVERY_CODE: 'Two Factor - Generate Recovery Code from Security Tab',
  GENERATE_RECOVERY_CODE_SUCCESS: 'Two Factor - Generate Recovery Code Success',
  GENERATE_RECOVERY_CODE_ERROR: 'Two Factor - Generate Recovery Code Error',
};

export const activationEvents = {
  VIEW_PAGE: 'Activation - View Page',
  START_FLOW: 'Activation - Start Flow',
  VIEW_STEP: 'Activation - View Step',
  CLICK_NEXT: 'Activation - Click Next',
  CLICK_BACK: 'Activation - Click Back',
  STEP_SUBMIT_ATTEMPT: 'Activation - Step Submit Attempt',
  STEP_SUBMIT_SUCCESS: 'Activation - Step Submit Success',
  STEP_SUBMIT_ERROR: 'Activation - Step Submit Error',
  STEP_VALIDATION_ERROR: 'Activation - Step Validation Error',
  DOCUMENT_UPLOAD_ATTEMPT: 'Activation - Document Upload Attempt',
  DOCUMENT_UPLOAD_SUCCESS: 'Activation - Document Upload Success',
  DOCUMENT_UPLOAD_ERROR: 'Activation - Document Upload Error',
  ABANDON_FLOW: 'Activation - Abandon Flow',
  COMPLETE_FLOW: 'Activation - Complete Flow',
  LAND_POST_COMPLETION: 'Activation - Land Post Completion',
};

export const bankingReportingEvents = {
  GENERATE_REPORT: 'Banking Reporting - Generate Report',
  SELECT_REPORT_TYPE: 'Banking Reporting - Select Report Type',
  CREATE_REPORT_EDIT_FIELD: 'Banking Reporting - Create Report Edit Field',
  DOWNLOAD_REPORT: 'Banking Reporting - Download Report',
  CLOSE_REPORT_DRAWER: 'Banking Reporting - Close Drawer',
};

export const revolvingCreditLineEvents = {
  SAVE_CREDIT_LINE_FORM: 'Revolving Credit Line - Save Credit Line Form',
  EDIT_CREDIT_LINE_FORM: 'Revolving Credit Line - Edit Credit Line Form',
  VIEW_REQUEST_PAGE: 'Revolving Credit Line - View Request Page',
  CLICK_LEARN_MORE: 'Revolving Credit Line - Click Learn More',
  OPEN_AMOUNT_DIALOG: 'Revolving Credit Line - Open Amount Dialog',
  SUBMIT_REQUEST: 'Revolving Credit Line - Submit Request',
  CLOSE_CONFIRMATION_MODAL: 'Revolving Credit Line - Close Confirmation Modal',
  CLICK_I_AGREE: 'Revolving Credit Line - Click I Agree',
  CLICK_COPY_TERMS_INFO: 'Revolving Credit Line - Click Copy Terms Info',
  INVOICES_TAB_VIEWED: 'Revolving Credit Line - Invoices Tab Viewed',
  INVOICE_DETAIL_OPENED: 'Revolving Credit Line - Invoice Detail Opened',
  VIEW_ALL_INVOICES: 'Revolving Credit Line - View All Invoices',
  INVOICE_MARK_NOT_ADVANCED: 'Revolving Credit Line - Invoice Mark Not Advanced',
  INVOICE_REVERT_NOT_ADVANCED: 'Revolving Credit Line - Invoice Revert Not Advanced',
  BLOCK_CREDIT_LINE: 'Revolving Credit Line - Block Credit Line',
  ACTIVATE_CREDIT_LINE: 'Revolving Credit Line - Activate Credit Line',
  DEACTIVATE_CREDIT_LINE: 'Revolving Credit Line - Deactivate Credit Line',
};

export const factoringCreditLineEvents = {
  PAGE_VIEWED: 'Factoring Credit Line - Page Viewed',
  TAB_SWITCHED: 'Factoring Credit Line - Tab Switched',
  SELECTION_CHANGED: 'Factoring Credit Line - Selection Changed',
  SELL_MODAL_OPENED: 'Factoring Credit Line - Sell Modal Opened',
  TERMS_ACCEPTED: 'Factoring Credit Line - Terms Accepted',
  CONFIRM_SALE_SUCCESS: 'Factoring Credit Line - Confirm Sale Success',
  CONFIRM_SALE_ERROR: 'Factoring Credit Line - Confirm Sale Error',
  REQUEST_DRAW_OPENED: 'Factoring Credit Line - Request Draw Opened',
  REQUEST_DRAW_CONFIRMED: 'Factoring Credit Line - Request Draw Confirmed',
  EXPORT_INVOICES: 'Factoring Credit Line - Export Invoices',
  EXPORT_ACTIVITY: 'Factoring Credit Line - Export Activity',
  UPDATE_INVOICES: 'Factoring Credit Line - Update Invoices',
  CLICK_GET_STARTED: 'Factoring Credit Line - Get Started',
  VIEW_REQUEST_PAGE: 'Factoring Credit Line - View Request Page',
  SUBMIT_REQUEST: 'Factoring Credit Line - Submit Request',
  CLICK_DISCOVER_MORE: 'Factoring Credit Line - Click Discover More',
  INVOICES_PAGE_VIEWED: 'Factoring Credit Line - Invoices Page Viewed',
  START_EXTRACTION: 'Factoring Credit Line - Start Extraction',
  SELL_PAGE_VIEWED: 'Factoring Credit Line - Sell Page Viewed',
  MAKE_PAYMENT_OPENED: 'Factoring Credit Line - Make Payment Opened',
};

export const recurringPaymentsEvents = {
  PAGE_VIEWED: 'Recurring Payments - Page Viewed',
  CREATE_STARTED: 'Recurring Payments - Create Started',
  CREATED: 'Recurring Payments - Created',
  EDITED: 'Recurring Payments - Edited',
  DELETED: 'Recurring Payments - Deleted',
  RETRY_CLICKED: 'Recurring Payments - Retry Clicked',
  EDIT_FIELD_RECURRING_TRANSFER_FORM: 'Recurring Payments - Edit Field Recurring Transfer Form',
  EDIT_FIELD_RECURRING_TRANSFER_EDIT_FORM: 'Recurring Payments - Edit Field Recurring Transfer Edit Form',
};

export const complianceBannerEvents = {
  COMPLIANCE_INVITE_SHOWN: 'Banner is rendered',
  COMPLIANCE_INVITE_CTA_CLICKED: 'Click on "Talk to an advisor"',
  COMPLIANCE_INVITE_DISMISSED: 'Click on the close (X) button',
};

export const invoicingEvents = {
  CONNECT_CLICK: 'Invoicing - Click Connect QuickBooks',
  CONNECT_SUCCESS: 'Invoicing - Connect QuickBooks Success',
  CONNECT_ERROR: 'Invoicing - Connect QuickBooks Error',
  START_CLICK: 'Invoicing - Click Start With Invoicing',
  MODAL_STEP1_QUICKBOOKS_SELECTED: 'Invoicing - Modal Select QuickBooks Option',
  MODAL_STEP1_HANDLED_SELECTED: 'Invoicing - Modal Select Handled For Me Option',
  MODAL_BACK_CLICK: 'Invoicing - Modal Back Click',
  MODAL_COMPLIANCE_REQUEST_SUBMIT: 'Invoicing - Modal Submit Compliance Request',
  DISCONNECT_CLICK: 'Invoicing - Click Disconnect QuickBooks',
  DISCONNECT_SUCCESS: 'Invoicing - Disconnect QuickBooks Success',
  DISCONNECT_ERROR: 'Invoicing - Disconnect QuickBooks Error',
  CLIENTS_LIST_VIEWED: 'Invoicing - Clients List Viewed',
  CLIENTS_SYNC_RETRY: 'Invoicing - Clients Sync Retry',
  CLIENTS_SYNC_REFRESH_CLICKED: 'Invoicing - Clients Sync Refresh Clicked',
  CLIENTS_FINANCING_TOGGLED: 'Invoicing - Clients Financing Toggled',
  PRODUCTS_LIST_VIEWED: 'Invoicing - Products List Viewed',
  PRODUCTS_SYNC_REFRESH_CLICKED: 'Invoicing - Products Sync Refresh Clicked',
  PRODUCTS_SYNC_RETRY: 'Invoicing - Products Sync Retry',
  NEW_INVOICE_STARTED: 'Invoicing - New Invoice Started',
  NEW_INVOICE_SAVED: 'Invoicing - New Invoice Saved',
  NEW_INVOICE_REVIEW_STARTED: 'Invoicing - New Invoice Review Started',
  NEW_INVOICE_SENT: 'Invoicing - New Invoice Sent',
  NEW_INVOICE_FAILED: 'Invoicing - New Invoice Failed',
  EDIT_INVOICE_STARTED: 'Invoicing - Edit Invoice Started',
  VIEW_INVOICE_STARTED: 'Invoicing - View Invoice Started',
  EDIT_INVOICE_CLICK: 'Invoicing - Click Edit Invoice',
  VIEW_INVOICE_CLICK: 'Invoicing - Click View Invoice',
  SEND_INVOICE_CLICK: 'Invoicing - Click Send Invoice',
  SEND_INVOICE_SUCCESS: 'Invoicing - Send Invoice Success',
  SEND_INVOICE_FAILED: 'Invoicing - Send Invoice Failed',
  DOWNLOAD_INVOICE_CLICK: 'Invoicing - Click Download Invoice',
};

export const complianceTermsEvents = {
  CLICK_TERMS_LINK: 'Compliance - Click Terms and Conditions Link',
  CONFIRM_TERMS: 'Compliance - Confirm Terms and Conditions',
};
